import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoaderService {
    loaderSubject = new Subject();

    constructor() { }

    show(text: string = '') {
        this.loaderSubject.next({ show: true, text: text });
    }

    hide() {
        this.loaderSubject.next({ show: false, text: '' });
    }
}